import * as shiftsActions from 'actions/shifts';

export const defaultState = {
  shiftId: '',
};

export default function mutateShiftsUrl(state = defaultState, action) {
  switch (action.type) {
    case shiftsActions.MUTATE_SHIFTS_URL:
      return {
        ...state,
        shiftId: action.payload,
      };
    default:
      return state;
  }
}
